import Vue from "vue";
import Vuex from "vuex";

import upgrade from "./modules/upgrade";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    upgrade,
  },
  mutations: {
    resetStore(state) {
      console.log("reset", state);
    },
  },
  strict: process.env.NODE_ENV !== "production",
});
